// SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
// Copyright (C) 2024 (original work) Open Assessment Technologies SA
//
// SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License

import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

export const routing = [
    {
        path: [config.routes.assets.home],
        guard: getPermissionsGuard([{ resource: 'portal.assets', scopes: ['view'] }]),
        controller: () => import('./controllers/assets')
    },
    {
        path: [config.routes.assets.create],
        guard: getPermissionsGuard([{ resource: 'portal.assets', scopes: ['create'] }]),
        controller: () => import('./controllers/asset')
    }
];
